import styled, { css } from 'styled-components';

import Step from '@/components/Redesign/Steps/components/Step';
import { media } from '@/utils/mixin';
import { HideScrollbar } from '@/components/styles';

import { StepsListProps } from './types';

function StepsList({ steps, columns = 6 }: StepsListProps) {
  return (
    <Component columns={columns}>
      {steps.map((step, index) => (
        <StepWrapper key={`step-${index}`}>
          <Step {...step} counter={index + 1} />
        </StepWrapper>
      ))}
    </Component>
  );
}

export default StepsList;

const Component = styled.div<{ columns: number }>`
  display: grid;
  gap: 30px;
  overflow: auto;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);

  ${media.tablet(css`
    justify-content: space-between;
    gap: 7px;
  `)}

  ${HideScrollbar};
`;

const StepWrapper = styled.div`
  ${media.tablet(css`
    min-width: 160px;
  `)}
`;
